<template>
    <nav v-if="!isElectron()" class="navbar navbar-expand-lg bg-white justify-content-center">
        <a href="/" :class="'navbar-brand'+(isLogin() ? 'ml-0 mr-auto m-lg-auto' : '')">
            <img src="/images/logo.png" title="ADBALU" style="height: 2rem;" />
        </a>
    </nav>
    <nav v-else class="navbar navbar-expand-lg bg-white justify-content-center">
        <a href="/"  :class="'navbar-brand'+(isLogin() ? 'ml-0 mr-auto m-lg-auto' : '')">
            <img src="/images/logo.png" title="ADBALU" style="height: 2rem;" />
        </a>
        <a href="#" @click="close();btnSfx();" class="nav-link mr-0">{{ $t('base.btn_close') }}</a>
    </nav>
</template>
<script>
import Vue from 'vue'

const Header = Vue.component('nav-header', {
    data () {
        return {
            name: ''
        }
    },
    methods:{
        btnSfx(){
            this.$store.dispatch('sound/sfx','Button');
        },
        isLogin(){
            return this.$store.state.auth.loggedIn;
        },
        close(){
            window.close();
        }
    },
    created () {
    }
})

export default Header
</script>